module.exports = "/images/69a8d09df38a7d57f1164b4d9e5f933c.png";